import styled from 'styled-components';

export const Container = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    max-width: 70%;
    width: 100%;
    margin: auto;
  }
`;
